const isLive = true;
const serverUrl = isLive ? "https://cms.bentenlab.com/api/v1/" : "http://localhost:1337/api/v1/";

const apis = {
    login: serverUrl + 'account/login',
    check_login: serverUrl + 'account/check-login',
    logout: serverUrl + 'account/logout',
    case: serverUrl + 'cases/case',
    common: serverUrl + 'common/common',
    task: serverUrl + 'task/task',
    appointment: serverUrl + 'appointment/appointment',
    statuslog: serverUrl + 'cases/statuslog',
    supportdocument: serverUrl + 'cases/supportdocument',
    supportprogram: serverUrl + 'cases/supportprogram',
    attachment: serverUrl + 'cases/attachment',
    award: serverUrl + 'award/award',
    forgotPassword: serverUrl + 'account/forgotpassword',
    casenote: serverUrl + 'cases/note'
}

export default apis;